import { DateTime } from "luxon";
import { useCallback } from "react";

import { useOptimizedMachineTimes } from "#modules/optimizations/view/useOptimizedMachineTimes";
import { makeQuoteRequestLinesCsv } from "#modules/quoteRequests/domain/makeQuoteRequestLinesCsv";
import { QuoteRequestAtom } from "#shared/view/components/AppShell/Atoms";

export const useQuoteRequestLinesCsvDownload = (quoteRequest: QuoteRequestAtom) => {
  const optimizedMachineTimes = useOptimizedMachineTimes(quoteRequest?.id);

  const downloadCsv = useCallback(() => {
    if (!quoteRequest) {
      return;
    }

    const csvData = makeQuoteRequestLinesCsv(
      quoteRequest.quoteRequestLines,
      quoteRequest.reference,
      optimizedMachineTimes,
    );

    const csvContent = csvData.join("\r\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    const formattedDate = DateTime.now().toFormat("yyyy-MM-dd-HH:mm");
    link.download = `${quoteRequest.reference ?? "-"}-${formattedDate}.csv`;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  }, [quoteRequest, optimizedMachineTimes]);

  return {
    downloadCsv,
    canDownload: !!quoteRequest && quoteRequest.quoteRequestLines.length > 0,
  };
};
